import { UnitProgramTaskQueuePage } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/Index'

export const UnitProgramTaskQueue = () => <UnitProgramTaskQueuePage />
